// extracted by mini-css-extract-plugin
module.exports = {"c-update-password-page__form":"UpdatePasswordPage_c-update-password-page__form__j1x9Y"};